export function convertToUnderscore(str){
    return str.trim().replace(/\s/g,'_').replace(/-/g,'_');
}
